// 获取hover的tab index
export function tabHoverIndex(dom, callback = () => {}) {
  if (!dom) {
    return;
  }
  const searchDom = (el) => {
    let dom = el;
    while (!dom.className.includes('ant-tabs-nav-list')) {
      if ([...dom.classList].includes('ant-tabs-tab')) {
        return dom;
      }
      dom = dom.parentNode;
    }
    return false;
  };

  dom.$el
    .querySelector('.ant-tabs-nav-list')
    .addEventListener('mouseover', (e) => {
      const target = e.target;
      const node = searchDom(target);
      if (!node) {
        return;
      }
      const parent = node.parentNode;
      const childs = parent.querySelectorAll('.ant-tabs-tab');
      const key = [].indexOf.call(childs, node);

      return callback(key);
    });
}
